interface CreateTeamMemberRequest {
  email: string
  fullName: string
  role: 'admin' | 'staff'
  businessId: string
  businessName: string
  businessType: 'tower' | 'parts_vendor' | 'garage' | 'insurer'
}

interface CreateTeamMemberResponse {
  success: boolean
  tempPassword?: string
  emailSent: boolean
  message: string
  error?: string
}

const API_BASE = import.meta.env.DEV 
  ? 'http://localhost:3001/api' 
  : '/api';

export async function createTeamMember(data: CreateTeamMemberRequest): Promise<CreateTeamMemberResponse> {
  try {
    const response = await fetch(`${API_BASE}/team/create-member`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (!response.ok) {
      return {
        success: false,
        emailSent: false,
        message: result.error || 'Failed to create team member',
        error: result.error
      };
    }

    return {
      success: true,
      tempPassword: result.tempPassword,
      emailSent: result.emailSent,
      message: result.message
    };
  } catch (error) {
    return {
      success: false,
      emailSent: false,
      message: `Network error: ${(error as any).message}`,
      error: (error as any).message
    };
  }
}
